import type { AppListenerApi } from "@src/store/rootState";

import { cancelContinuation, vivStreamAction } from "../actions";
import { CONTINUATION_TERMINAL_TIMEOUT } from "./constants";
import { isFinishFor, isTerminalFor } from "./detect";

/**
 * Block until the turn ends. Resolves `true` when the stream's `finish` for
 * `turnId` arrives (fire the continuation), `false` if the turn is aborted
 * first — a stop (`cancelContinuation`), a turn error (`setError` for this
 * turn), or the backstop timeout. Both terminal arms are scoped to `turnId`,
 * so a terminal from an unrelated turn never resolves this. Registered
 * *before* the side effect is applied, because `finish` routinely lands while
 * we're still inside `waitForSettle`.
 */
export async function awaitTurnFinished(
  api: AppListenerApi,
  turnId: string
): Promise<boolean> {
  const taken = await api.take(
    (a) =>
      cancelContinuation.match(a) ||
      (vivStreamAction.match(a) && isTerminalFor(a.payload.data, turnId)),
    CONTINUATION_TERMINAL_TIMEOUT
  );
  const terminal = taken?.[0];
  return (
    !!terminal &&
    vivStreamAction.match(terminal) &&
    isFinishFor(terminal.payload.data, turnId)
  );
}
